<template>
  <div>
    <Operator
      :disabled="disabled"
      :operators="operators"
      :value.sync="compareType"/>
    <sFormItem
      v-if="$_showParametersWithOperator && spr && spr.length"
      class="parameters"
      prop="parameters"
      :rules="parametersRules">
      <sSelect
        class="width-100 mt-1"
        data-qa="condition-props-list"
        :disabled="disabled"
        filterable
        multiple
        :placeholder="$t('Common.Select')"
        :value.sync="parameters">
        <sOption
          v-for="sprItem in spr"
          :key="`condition-props-${sprItem.key}`"
          :data-qa="`option-${sprItem.key}`"
          :disabled="disabled"
          :label="sprItem.label"
          :value="sprItem.key">
          <div>
            <div>{{ sprItem.label }}</div>
            <div
              v-if="sprItem.description"
              class="font-size-12 opacity-8">
              {{ sprItem.description }}
            </div>
          </div>
        </sOption>
      </sSelect>
    </sFormItem>
  </div>
</template>
<script>
import Operator from 'components/automation/conditions/default/operator.vue'
import automations from 'mixins/automations.js'

/**
 * Компонент списка
 */
export default {
  name: 'SimpleFieldList',
  mixins: [ automations ],
  data() {
    const that = this
    return {
      parametersRules: {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!that.parameters?.length) {
            callback(new Error(that.$t('Validate.Required')))
          }
          callback()
        },
      },
    }
  },
  computed: {
    compareType: {
      get() {
        if (!this.value?.compareType) {
          return null
        }
        return this.value.compareType
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)
        result.compareType = newValue
        if (!this.$_showParametersWithOperator) {
          result.parameters = null
        }
        this.$emit('update:value', result)
      }
    },
    parameters: {
      get() {
        if (!this.value?.parameters) {
          return null
        }
        try {
          const parseParam = JSON.parse(this.value.parameters) || []
          return Array.isArray(parseParam) ? parseParam : []
        } catch {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Tenders.ErrorConditionParams'),
            showClose: true,
            progress: true,
          })
          return []
        }
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)

        result.parameters = JSON.stringify(newValue)
        this.$emit('update:value', result)
      }
    },
  },
  watch: {
    $_showParametersWithOperator: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue && !newValue) {
          this.parameters = null
        }
      }
    }
  },
  components: {
    Operator
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
    spr: {
      type: Array
    },
  },
}
</script>
<style scoped lang="scss">
.comparation,
.parameters {
  width: 300px;
  margin-top: 15px;
}
</style>
